export const EXTERNAL_LINKS = {
  PUBLICATION_RANK:
    "https://platform-support.onclusive.com/en/articles/302159-publication-rank",
  NLA_CONTENT_RULES:
    "https://platform-support.onclusive.com/en/articles/396002-understanding-nla-content-rules-and-how-they-affect-search-results",
  RELEVANCE_SCORES:
    "https://platform-support.onclusive.com/en/articles/302145-understand-mention-relevance",
  NLA_ECLIPS_URL:
    "https://www.nla-eclips.com/NLAAPI.dll/PCAClientRequest?PCA_ID=100",
  REALTIME_DIGEST_LOCKED_CONTENT:
    "https://platform-support.onclusive.com/en/articles/425205-managing-locked-and-unlocked-content-in-your-email-digests",
  DIGEST_ALERTS_LEARN_MORE:
    "https://platform-support.onclusive.com/en/articles/302044-set-up-digest-alerts#h_e7af58e10c",
  REALTIME_ALERTS_LOCKED_CONTENT:
    "https://platform-support.onclusive.com/en/articles/302127-set-up-real-time-alerts#h_5bd558cd29",
  BOOLEAN_SEARCH_GUIDE:
    "https://platform-support.onclusive.com/en/articles/302165-guide-to-boolean-searches",
  MONITOR_ENQUIRY:
    "https://onclusive.com/en-gb/products/self-service-media-monitoring/#enquiry",
  CONTACTS_ENQUIRY:
    "https://onclusive.com/en-gb/products/media-contacts-events-database/#enquiry",
};
